import React from "react";
import { connect } from "react-redux";
import { showError } from "actions/notification";
import { registerUser } from "actions/user";
import logo from "assets/logo.jpg";
import { replace } from "connected-react-router";
import LinkedInAuthButton from "containers/Login/components/LinkedInAuthButton";
import PropTypes from "prop-types";

import Card, { CardBlock } from "components/Card";
import ScreenWidth from "components/hoc/ScreenWidth";
import DataStorage from "utils/DataStorage";
import getLocale from "utils/locale";
import Translate from "utils/translate";
import { getUrlParams } from "utils/urlParams";

import LocaleSwitch from "./LocaleSwitch";
import styles from "../../SignUp.css";

const { t } = new Translate("SignUp");

export class User extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      locale: getLocale(),
      user: null,
    };

    this.handleRegister = this.handleRegister.bind(this);
    this.handleUpdateLocale = this.handleUpdateLocale.bind(this);
  }

  handleRegister(user) {
    const { campaign, onError, onRegister, setFieldError } = this.props;
    if (!!campaign && (!user.company || !user.company.id)) {
      onError();
      setFieldError("company.name", "Company not found");
    }

    return onRegister(user).then(({ value }) => this.setState({ user: value.user }));
  }

  handleUpdateLocale(locale) {
    DataStorage.setUserLocale(locale);
    this.setState({ locale });
  }

  render() {
    const { campaign } = this.props;
    const { locale, user } = this.state;

    return (
      <>
        <LocaleSwitch locale={locale} onSwitch={this.handleUpdateLocale} />
        <Card className={styles.container}>
          <CardBlock>
            <img alt="" src={logo} width="195" />
          </CardBlock>
          {user ? (
            <CardBlock>
              <p
                dangerouslySetInnerHTML={{
                  __html: t(campaign ? "submittedCampaign" : "submitted", {
                    fname: user.fname,
                  }),
                }}
              />
            </CardBlock>
          ) : (
            <>
              <CardBlock className={styles.tagline}>
                <h1>{t("title")}</h1>
                <p>
                  <span dangerouslySetInnerHTML={{ __html: t("tagline") }} />
                </p>
                {!campaign && (
                  <LinkedInAuthButton
                    text={t("linkedin_signup")}
                    url={`https://www.linkedin.com/oauth/v2/authorization?client_id=${linkedinClientId}&redirect_uri=${window.location.origin}/oauth/linkedin&response_type=code&scope=r_liteprofile%20r_emailaddress&state=register`}
                  />
                )}
              </CardBlock>
              <CardBlock>
                We are currently limiting user accounts, please contact hello@rial.to for more info.
              </CardBlock>
            </>
          )}
        </Card>
      </>
    );
  }
}

User.propTypes = {
  campaign: PropTypes.string,
  company: PropTypes.shape({
    role: PropTypes.string,
  }),
  onError: PropTypes.func.isRequired,
  onRegister: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
};

const mapStateToProps = () => {
  const { campaign } = getUrlParams();

  return {
    campaign,
    company: campaign && { role: "broker" },
  };
};

const mapDispatchToProps = (dispatch) => ({
  onCancel: () => dispatch(replace("/login")),
  onError: () => dispatch(showError("Company not found", "Please select one from the list")),
  onRegister: ({ company = {}, ...user }) =>
    dispatch(
      registerUser(
        {
          ...user,
          locale:
            company.type === "flex"
              ? `${DataStorage.getUserLocale()}-flex`
              : DataStorage.getUserLocale(),
          companyId: company.id,
        },
        getUrlParams()
      )
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScreenWidth(User));
